import { Injectable } from '@angular/core';
import { Observable, lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EndPointApi } from '@helpers/endpointapi';

@Injectable({ providedIn: 'root' })
export class SimulatorService {
    private domain: string;
    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    public getUrl(): Promise<{simulatorUrl: string}> {
        return lastValueFrom(
            this.http.get<{simulatorUrl: string}>(`${this.domain}/api/simulator/activeUrl`),
        );
    }

    public checkSimulatorStatus(): Promise<{isActive: boolean}> {
        return lastValueFrom(
            this.http.get<{isActive: boolean}>(`${this.domain}/api/simulator/status`),
        );
    }
}
